/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/*global console */

expocadfx.DisplayExhibitor  = function( exhObj, viewName, idx, isChild) {
	'use strict';
	var exh = {
		id: idx,              /* Needed for slick grid sort and filter */
		name: "",
		exhId: "",
		location: "",
        boothNumber: "",
        arBoothNumbers: [],
        arBoothIndexes: [],
		viewName: viewName,
		boothIndex: "",
		exhibIndex: "",
		favorite: false,
		bLocal: true,
        bAvailable: false,
		priority: 0
	};
	
	if( exhObj !== null) {
		exh.name = exhObj.name;
		exh.exhId = exhObj.exhId;
		exh.location = exhObj.boothNumber;
        exh.arBoothIndexes.push( exhObj.boothIndex);
        exh.arBoothNumbers.push( exhObj.boothNumber);
        exh.boothNumber = exhObj.boothNumber;
		exh.boothIndex = exhObj.boothIndex;
		exh.exhibIndex = exhObj.id;
        
        if( expocadfx.fxData.booths[ exhObj.boothIndex]) {
        
			exh.bAvailable = expocadfx.fxData.booths[ exhObj.boothIndex].status === "0";
			
			if(isChild){
				expocadfx.fxData.booths[exhObj.boothIndex].exhibitorIndex += "," + exh.id;
			}
        }
        else {
            console.log( "Display object - no booth to get status -  booth number: " + exhObj.boothNumber + 
                        "  index: " + exhObj.boothIndex);
        }
	}
    return exh;
};